/**
 * Milkdown wiring for table cell images: remark pass, `transformPasted`, and prepend `handlePaste`
 * (Crepe clipboard bypasses `transformPasted`).
 * Core logic lives in {@link ./tableCellImage}.
 */
import { $prose, $remark } from '@milkdown/kit/utils';

import { createTableCellImageTransformPlugin, revertImageBlocksToInlineInTableCells } from './tableCellImage';

export { tableCellImagePastePlugin } from './tableCellImagePastePlugin';

/** Runs after `remark-image-block` so invalid `image-block` inside `tableCell` becomes `paragraph`+`image`. */
export const tableCellImageRemark = $remark('table-cell-image', () => () => revertImageBlocksToInlineInTableCells);

/** Rewrites pasted `image-block` slices to inline `image` when the cursor is in a table cell (default PM paste). */
export const tableCellImageTransform = $prose(() => createTableCellImageTransformPlugin());

export { createCellImageNode } from './tableCellImage';
